import { graphql, useStaticQuery } from 'gatsby';

const Testimonials = () => {
  const data = useStaticQuery(graphql`
    query {
      CyrilLesot: file(relativePath: { eq: "google reviews/2023-01-cyril.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      PaulineBouchereau: file(relativePath: { eq: "google reviews/2023-01-pauline.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      FlorianeLefebvre: file(relativePath: { eq: "google reviews/2023-01-floriane.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      HugoGarnier: file(relativePath: { eq: "google reviews/2023-01-hugo.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      EmilyLeDeunf: file(relativePath: { eq: "google reviews/2023-01-emily.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      JoshRivas: file(relativePath: { eq: "google reviews/2023-01-josh.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      JohannPouponnot: file(relativePath: { eq: "google reviews/2023-01-johann.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      QuentinChapon: file(relativePath: { eq: "google reviews/2023-01-quentin.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      LouiseGrillon: file(relativePath: { eq: "google reviews/2023-01-louise.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      JulieDee: file(relativePath: { eq: "google reviews/2023-01-julie.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      NicolasBenais: file(relativePath: { eq: "google reviews/2023-01-nicolas.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      MihoubDebache: file(relativePath: { eq: "google reviews/2023-01-mihoub.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
      ThibaudVincent: file(relativePath: { eq: "google reviews/2023-01-thibaud.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 50, width: 100, placeholder: NONE)
        }
      }
    }
  `);
  const dataTestimonials = [
    /////////////
    /////////////
    // BOOTCAMP
    /////////////
    /////////////
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Cyril Lesot',
      avatar: data.CyrilLesot.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Le Reacteur est ce type de formation qui vous fait passer d'un niveau débutant / découverte à un niveau qui vous permet de travailler en entreprises. Deux mois et demie de formation intensive ou tout est réuni pour escalader ce mur qui vous avez paru infranchissable pour devenir développeur. La qualité de la formation, les supports, les enseignants et les nombreux projets qui vous accompagnent sont à jour et d'excellente qualités. Foncez, vous ne serez pas déçu.",
      isActive: true,
      reviewLink: 'https://g.co/kgs/yYubJE',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Pauline Bouchereau',
      avatar: data.PaulineBouchereau.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Une très bonne formation, le programme est bien pensé et très graduel (même si bien sûr intense), les exercices et différents projets à réaliser sont très intéressants et permettent de bien appliquer les notions vues en cours. L'équipe est top, très pédagogue. En résumé, un bootcamp qui permet d'obtenir des bases très solides pour se lancer dans le développement !",
      isActive: true,
      reviewLink: 'https://g.co/kgs/ZqWDrD',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Floriane Lefebvre',
      avatar: data.FlorianeLefebvre.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Super formation, on est accompagnés du début à la fin, depuis l'inscription aux conseils pour rédiger son CV, réussir un entretien,  ou parfaire son portfolio (bien entamé pendant la formation), je recommande !",
      isActive: true,
      reviewLink: 'https://g.co/kgs/PNE55o',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Hugo Garnier',
      avatar: data.HugoGarnier.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Très bon bootcamp avec une équipe compétente, un programme très fournit et à jour (React - React Native - Node JS) ! L'équipe est chaleureuse et d'un super niveau technique. Que l'on soit déjà dev, avec des connaissances ou complètement débutant, c'est une superbe opportunité. Je recommande chaudement.",
      isActive: true,
      reviewLink: 'https://g.co/kgs/mh8Ggp',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Emily Le Deunf',
      avatar: data.EmilyLeDeunf.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Formation de qualité dispensée sur 10 semaines : contenu du programme pertinent, formateurs compétents et format tout à fait adapté pour assurer une progression rapide (cours matin / application l'après-midi avec aide d'un instructeur). Je recommande vivement pour toute personne souhaitant entamer une reconversion professionnelle.",
      isActive: true,
      reviewLink: 'https://g.co/kgs/7mmFqF',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Josh Rivas',
      avatar: data.JoshRivas.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "La formation de haut niveau et l'encadrement que j'ai reçus lors de mon expérience de Bootcamp de 10 semaines au Reacteur, m'ont permis de passer de développeur occasionnel à développeur professionnel. Le programme se concentre sur les technologies et les compétences les plus recherchées sur le marché du travail. Bien que les professeurs soient toujours disponibles pour aider, ils enseignent et encouragent à résoudre les problèmes soi-même - ce qui est évidemment une compétence essentielle pour tout développeur en devenir. Grâce à ce que j'ai appris au Reacteur, j'ai pu obtenir plusieurs offres de stage et commencer à travailler en tant que développeur.",
      isActive: true,
      reviewLink: 'https://g.co/kgs/66bbsU',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Johann Pouponnot',
      avatar: data.JohannPouponnot.childImageSharp.gatsbyImageData,
      stars: 5,
      text: 'Tout juste sorti du Bootcamp et super heureux de ces 10 semaines. Le Reacteur tient ses promesses ! Quelques soient les bases de départ, une véritable montée en compétences à la clé. Pour ne rien gâcher, une équipe au top, sympa et dynamique, la rencontre de camarades passionnés et un projet de fin de formation super challengeant ! Merci au Reacteur pour ces dix (trop courtes) semaines.',
      isActive: true,
      reviewLink: 'https://g.co/kgs/GKjRtc',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Quentin Chapon',
      avatar: data.QuentinChapon.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Le Bootcamp parfait si vous voulez vous lancer dans le développement Web et mobile ! Choix de la techno (React), programme, formateurs, projets, locaux, ambiance : tout est réuni pour vous propulser au top, quel que soit votre niveau. La courbe d'apprentissage est excellente, vous serez accompagné de A à Z et serez capable de mettre en place des sites et des applis mobile à la fin des deux mois et demi de formation. Je le referais sans hésiter. Foncez !",
      isActive: true,
      reviewLink: 'https://g.co/kgs/1UvtSk',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Louise Grillon',
      avatar: data.LouiseGrillon.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Voulant devenir développeuse Web mais sans m'investir dans de longues années d'études/formations, j'ai découvert Le Reacteur et son bootcamp, une formation intensive répondant parfaitement à mes objectifs ! Ce fut une super bonne expérience, j'ai très rapidement pu constater une montée en compétence afin me sentir à niveau pour entrer dans le monde professionnel. En plus de ça il y'a une très bonne ambiance, l'équipe de formateurs est bien présente et à l'écoute ! Trop bien !",
      isActive: true,
      reviewLink: 'https://g.co/kgs/acM2y5',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Julie Dee',
      avatar: data.JulieDee.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Je recommande vivement cette formation. J'ai eu la chance d'intégrer la promotion de l'été 2022 suite à une reconversion professionnelle. 4 mois de cours intensifs ou nous apprenons les bases de javascript, React et React Native tout en réalisant des projets concrets Fullstack et même la possibilité de réaliser un MVP pour un vrai client lors de la dernière semaine de cours.",
      isActive: true,
      reviewLink: 'https://g.co/kgs/RoZV16',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Nicolas Benais',
      avatar: data.NicolasBenais.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "On m'a dit que c'était le meilleur bootcamp en France. C'est intense, il y a du challenge, on apprend beaucoup de choses... Bref, si Le Reacteur c'est pas le number 1, je sais pas qui d'autre peut l'être.",
      isActive: true,
      reviewLink: 'https://g.co/kgs/NwxWmi',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Mihoub Debache',
      avatar: data.MihoubDebache.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Si vous voulez changer de vie pour devenir développeur web, c'est au Reacteur que ça commencera. Ce que l'on y apprend sont les languages les plus recherchés (Javascript - React) J'ai trouvé ma première expérience de développeur Web fullstack 1 mois seulement après ma formation. Les formateurs sont top et à l'écoute. Des petits conseils pour réussir :  soyez attentif, concentré, assidue et buvez les paroles de Xavier. Il n'est pas du genre à mâcher ses mots, mais il sait ce qu'il faut pour réussir. Foncez!",
      isActive: true,
      reviewLink: 'https://g.co/kgs/AHtN84',
    },
    {
      course: 'formation-developpeur-web-mobile',
      name: 'Thibaud Vincent',
      avatar: data.ThibaudVincent.childImageSharp.gatsbyImageData,
      stars: 5,
      text: "Une formation sans chichi sans pincette, on est là pour manger du code matin, midi et soir et même la nuit dans les rêves. Très professionnelle, avec une attention dans l'évolution de l'apprentissage. La formule est bien construite, elle nous confronte réellement au monde professionnel des développeurs et pas juste à la théorie. En suivant cette formation on comprend toute l'importance du prof de math qui nous demandé d'expliquer la résolution d'un problème. Vous comprendrez pourquoi je dis ça en fonçant vous former au Reacteur. Des Profs au top, disponible. L'apprentissage des dernières avancées sur la tech React et React Native. Et une convention de stage en sorti de formation. Tout est fait pour réussir.",
      isActive: true,
      reviewLink: 'https://g.co/kgs/VmH6aS',
    },
    /////////////
    /////////////
    // REACT REDUX
    /////////////
    /////////////
    {
      course: 'react-native',
      name: 'Thibaud Dervily',
      avatar:
        '//lh3.googleusercontent.com/-xbg77G16kx8/AAAAAAAAAAI/AAAAAAAAAGM/6Mc4JeD5T8g/photo.jpg',
      stars: 5,
      text: 'La formation react-native était vraiment top. Le formateur et les collaborateurs du Reacteur, sont vraiment tous très bon. Je recommande vivement cet organisme.',
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Mickaël Randrianarisoa',
      avatar:
        '//lh5.googleusercontent.com/-ArrCgBk-fA4/AAAAAAAAAAI/AAAAAAAAAGs/CX1DcZQTMIk/photo.jpg',
      stars: 5,
      text: "Excellente formation, excellents formateurs, très bonne pédagogie, sympathiques et à l'écoute de toutes vos attentes. Je conseille fortement.",
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Jean-Guillaume Larue',
      avatar: null,
      stars: 5,
      text: "Un centre de formation qui respire le professionnalisme, la technicité et une disponibilité hors pair, sans oubliant un savoir de l'accueil et une bienveillance. Une bonne ambiance qui donne envie d'apprendre. Chaque jour, vous vous sentez plus fort ! N'hésitez plus, inscrivez-vous pour la prochaine session ou demandez plus d'information à Kevin. \"All for the love of you !\" (Extrait d'une réplique du film de l'Odyssée de l'espace, dédicace à Farid, sans ambiguîté:) A très bientôt !",
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Gaëtan Duhamel',
      avatar:
        '//lh5.googleusercontent.com/-OFLa9Qza3Mo/AAAAAAAAAAI/AAAAAAAAADE/WO4GhcGdK9E/photo.jpg',
      stars: 5,
      text: "Avec l'équipe du Reacteur, j'ai eu la chance de suivre une formation React Native qui a dépassé, de loin, mes attentes les plus ambitieuses. Complètement novice sur la technologie, je sors de la formation avec une preuve de concept que je vais pouvoir présenter à mon équipe dès la semaine prochaine... et surtout de solides bases en React pour continuer mon apprentissage en autonomie. Merci à Farid et Kévin pour la chaleur de leur accueil, leurs conseils et surtout leur patience! Une formation à réserver les yeux fermés.",
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Fidinirina Randria',
      avatar:
        '//lh3.googleusercontent.com/-tTCg5abbD7s/AAAAAAAAAAI/AAAAAAAAADk/XGx3MIVym6E/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'Programme de formation bien adapté à un groupe. Un bon équilibre entre la partie théorique et la partie pratique. La présence de deux formateurs augmente la qualité des échanges et particulièrement pendant les TP. Enfin, les formateurs maitrisent bien leur sujet.',
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Yoan Mettan',
      avatar:
        '//lh4.googleusercontent.com/-G1uthrW7cnU/AAAAAAAAAAI/AAAAAAAAAB4/HmgjiafDXxw/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'Formation en entreprise très complète sur React Native. Excellente disponibilité du formateur et souplesse du programme en fonction de nos attente.',
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Geoffrey Liv',
      avatar:
        '//lh5.googleusercontent.com/-OFLa9Qza3Mo/AAAAAAAAAAI/AAAAAAAAADE/WO4GhcGdK9E/photo.jpg',
      stars: 5,
      text: "Super formation React Native, avec exercices progressifs. Les formateurs sont pédagogues et à l'écoute des besoins (et super sympas au passage). N'ayant aucune expérience préalable en dev mobile, je me suis tout de suite senti à l'aise avec les cours. Je recommande fortement la formation à toute personne qui voudrait se lancer dans le mobile.",
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Amandine Miceli',
      avatar:
        '//lh5.googleusercontent.com/-5mJrTa0mLJ8/AAAAAAAAAAI/AAAAAAAAABE/Ce0Ec8Ncygs/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'Formateurs pédagogues, enthousiastes et passionnés par leur techno. Prêts à distiller de bons conseils et des ressources utiles. Tout cela dans une bonne ambiance. À recommander.',
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Kevin Grabiner',
      avatar:
        '//lh3.googleusercontent.com/-CON7WcgCPQA/AAAAAAAAAAI/AAAAAAAAAP8/xIxPymtmOSw/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'Superbe formation React Native ! Formation complète et passionnante. Merci encore',
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Baptiste Briois',
      avatar: null,
      stars: 5,
      text: 'Une équipe et une formation React Native au top ! Formation très bien organisée et adaptée à nos besoins. Rien à redire, foncez !',
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Romain Cherix',
      avatar:
        '//lh6.googleusercontent.com/-ihGsVSKXk88/AAAAAAAAAAI/AAAAAAAAACk/5ERpk1ljDVY/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: "Excellente approche pour une formation rapide d'une semaine sur react native.",
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Frédéric De Michielis',
      avatar:
        '//lh3.googleusercontent.com/-5qUriPmhBQ0/AAAAAAAAAAI/AAAAAAAAP10/lCjAKem1PoY/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'Très bonne formation react-native.',
      isActive: true,
    },

    {
      course: 'react-native',
      name: 'Norbert AtHome',
      avatar: null,
      stars: 5,
      text: 'Formation sur React Native très intéressante !',
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Benjamin Michel',
      avatar:
        '//lh6.googleusercontent.com/-fmaB7ltF2ok/AAAAAAAAAAI/AAAAAAAAED4/PgKp4nCHTfE/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'A great React Native training. Farid definitely knows how to share his experience and knowledge. Highly recommended!',
      isActive: true,
    },
    {
      course: 'react-native',
      name: 'Waseem Saumtally',
      avatar: null,
      stars: 5,
      text: 'An excellent way to start with React Native programming. Well organized training with excellent communication from both Xavier and Farid. Would highly recommend.',
      isActive: true,
    },
    /////////////
    /////////////
    // REACT REDUX
    /////////////
    /////////////
    {
      course: 'react-redux',
      name: 'Tom L.',
      avatar:
        '//lh4.googleusercontent.com/-dYfdtVlaCps/AAAAAAAAAAI/AAAAAAAAAFo/P1PGPymQXjA/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'Mindblowing training. Thumbs up for the shared knowledge and experience!',
      isActive: true,
    },
    {
      course: 'react-redux',
      name: 'Xc Chen',
      avatar:
        '//lh6.googleusercontent.com/-gIOA6cP7MBw/AAAAAAAAAAI/AAAAAAAAAv0/i7DRFQAraFs/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'Great experience with very useful instructions and practices! Would definitely recommend!',
      isActive: true,
    },
    {
      course: 'react-redux',
      name: 'Didier Bonnet',
      avatar: null,
      stars: 5,
      text: 'Très bonne formation !',
      isActive: true,
    },
    {
      course: 'react-redux',
      name: 'Florian Tonnelier',
      avatar: null,
      stars: 5,
      text: 'Super formation ! Merci encore ;-)',
      isActive: true,
    },
    {
      course: 'react-redux',
      name: 'Vesic Dejan',
      avatar: null,
      stars: 5,
      text: 'Très bonne formation pour démarrer avec React',
      isActive: true,
    },
    {
      course: 'react-redux',
      name: 'Vincent Miquel',
      avatar: null,
      stars: 5,
      text: "Très bonne formation, très complète avec pas mal d'exercices pratiques. Je recommande !",
      isActive: true,
    },
    {
      course: 'react-redux',
      name: 'Anis Ayadi',
      avatar:
        '//lh3.googleusercontent.com/-tCLJpgQp8Kw/AAAAAAAAAAI/AAAAAAAAAn8/CRM07pLW5yg/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: "J'ai suivi la formation React + Redux. Le contenu est très pertinent et à jour. Formateur très compétent, à l'écoute, il a su répondre à toute mes interrogations sur REACT, REDUX et plus encore. Il nous a prodigué les bonnes pratiques qu'il a pu acquérir avec son expérience. Si j'ai l'occasion je n'hésiterai pas à suivre la formation React Native, pour étendre mon apprentissage au domaine du mobile. Merci",
      isActive: true,
    },
    {
      course: 'react-redux',
      name: 'Vincent Berthe',
      avatar:
        '//lh4.googleusercontent.com/-ktG74-coVFo/AAAAAAAAAAI/AAAAAAAADdw/tyeW1K8b9iA/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'Très bonne formation, en petit groupe, idéal pour poser des questions et progresser.',
      isActive: true,
    },
    {
      course: 'react-avance',
      name: 'Florian Tonnelier',
      avatar: null,
      stars: 5,
      text: 'Super formation ! Merci encore ;-)',
      isActive: true,
    },
    {
      course: 'react-avance',
      name: 'Vesic Dejan',
      avatar: null,
      stars: 5,
      text: 'Très bonne formation pour démarrer avec React',
      isActive: true,
    },
    {
      course: 'react-avance',
      name: 'Vincent Miquel',
      avatar: null,
      stars: 5,
      text: "Très bonne formation, très complète avec pas mal d'exercices pratiques. Je recommande !",
      isActive: true,
    },
    {
      course: 'react-avance',
      name: 'Anis Ayadi',
      avatar:
        '//lh3.googleusercontent.com/-tCLJpgQp8Kw/AAAAAAAAAAI/AAAAAAAAAn8/CRM07pLW5yg/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: "J'ai suivi la formation React + Redux. Le contenu est très pertinent et à jour. Formateur très compétent, à l'écoute, il a su répondre à toute mes interrogations sur REACT, REDUX et plus encore. Il nous a prodigué les bonnes pratiques qu'il a pu acquérir avec son expérience. Si j'ai l'occasion je n'hésiterai pas à suivre la formation React Native, pour étendre mon apprentissage au domaine du mobile. Merci",
      isActive: true,
    },
    {
      course: 'react-avance',
      name: 'Vincent Berthe',
      avatar:
        '//lh4.googleusercontent.com/-ktG74-coVFo/AAAAAAAAAAI/AAAAAAAADdw/tyeW1K8b9iA/s40-c0x00000000-cc-rp-mo/photo.jpg',
      stars: 5,
      text: 'Très bonne formation, en petit groupe, idéal pour poser des questions et progresser.',
      isActive: true,
    },
    /////////////
    /////////////
    // LANDING PAGES
    /////////////
    /////////////
    {
      course: 'landingPage',
      name: 'Cyril Lesot',
      avatar: data.CyrilLesot.childImageSharp.gatsbyImageData,
      stars: 5,
      title: 'Une formation professionnalisante',
      text: "Le Reacteur est ce type de formation qui vous fait passer d'un niveau débutant / découverte à un niveau qui vous permet de travailler en entreprise.",
    },
    {
      course: 'landingPage',
      name: 'Pauline Bouchereau',
      avatar: data.PaulineBouchereau.childImageSharp.gatsbyImageData,
      stars: 5,
      title: 'Des bases solides pour se lancer',
      text: 'Le programme est bien pensé et graduel, les projets à réaliser permettent de bien appliquer les notions vues en cours, et l’équipe est très pédagogue !',
    },
    {
      course: 'landingPage',
      name: 'Mihoub Debache',
      avatar: data.MihoubDebache.childImageSharp.gatsbyImageData,
      stars: 5,
      title: 'Idéal pour se reconvertir !',
      text: 'Au Reacteur, on apprend les langages les plus recherchés. J’ai trouvé ma première expérience de Développeur 1 mois seulement après ma formation.',
    },
  ];
  return dataTestimonials;
};

export default Testimonials;
